var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not_found"},[_c('div',{staticClass:"error_message"},[_vm._v("\n    アクセスしようとしたページは、権限がないため表示できません。\n  ")]),_c('div',[(
        _vm.$hasAllRequiredPermission(
          ['DASHBOARD:READ'],
          _vm.$store.state.auth.loginInfo
        )
      )?_c('v-btn',{staticClass:"blue white--text",attrs:{"depressed":""},on:{"click":function($event){return _vm.onClickGoToTopPage()}}},[_vm._v("トップページへ")]):_c('v-btn',{staticClass:"blue white--text",attrs:{"depressed":""},on:{"click":function($event){return _vm.logout()}}},[_vm._v("ログアウト")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }